export function convertCentsToDollars(cents: number): string {
  const dollars = cents / 100;
  return dollars.toFixed(2);
}

export function convertCentsToDollarsNumber(cents: number): number {
  return cents / 100;
}
